
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

export default {
data() {
return {
money:'',
pay_money:'',
pay_saleuser:'',
position: 'default',
showPositionValue: false,
tiptxt:'',
tipType:'',
}
},
mounted() {
this.getmoney()
},
methods: {
showPosition (position) {
this.position = position
this.showPositionValue = true
},
getmoney() {
let data = 'cmd=userinfo';
this.$http.post('https://api.abeiyun.com/www/user.php', data).then(({data}) => {
if(data.response == 200) {
this.money = data.msg.money;
}

})
}

},
components: {
PopupPicker
}
}



// WEBPACK FOOTER //
// ./src/components/finance/payment.vue